<header class="header bg-revision-hub text-white pt-2" [style.--header-colour]="headerParamsService.headerColour()">
  <div class="header-container"> <!--previously container class-->
    <div class="row">
      <div class="col-12 px-4">
        <nav class="nav d-flex justify-content-between align-items-center" style="height:64px; margin: 0 auto;">
          <!-- Left side: Logo and Title -->
          <div class="d-flex align-items-center gap-1 header-title-container">
            <a class="cgp-logo-link" [href]="logoLink()"><img class="cgp-logo"
                                        src="/assets/images/cgp-logo.png"
                                        alt="CGP RevisionHub" style=""></a>
            @if (showHeaderTitleProductSelector()) {
              <div class="header-title-swap align-items-center"
                   [class.is-default]="headerParamsService.isDefaultHeader()">
                <h1 class="mb-0 header-text-center header-title-swap__text"></h1>
                <img src="/assets/images/cgp-online-products-logo.png"
                     alt="CGP Online Products" class="online-products-logo header-title-swap__logo">
              </div>
            }
            @if (showHeaderTitle()) {
              <div class="header-title-swap align-items-center"
                   [class.is-default]="headerParamsService.isDefaultHeader()">
                <h1 class="mb-0 header-text-center header-title-swap__text">{{ headerParamsService.headerTitle() }}</h1>
                <img src="/assets/images/revision-hub-white-logo.png"
                     alt="CGP RevisionHub" class="revision-hub-logo header-title-swap__logo">
              </div>
            }
            @if (showHeaderTitleElevenPlus()) {
              <div class="header-title-swap align-items-center"
                   [class.is-default]="headerParamsService.isDefaultHeader()">
                <h1 class="mb-0 header-text-center header-title-swap__text">{{ headerParamsService.headerTitle() }}</h1>
                <img src="/assets/images/11-plus-online-logo-white.png"
                     alt="11+ Online" class="eleven-plus-hub-logo header-title-swap__logo">
              </div>
            }
          </div>
          @if (headerParamsService.isElevenPlus() && headerParamsService.showProfileInfo()) {
            <div class="d-flex align-items-center pupil-info-container">
              <span class="mobileHeaderHidden pupil-name">{{pupilMemberService.getPupilDisplayName()}}</span>
              @if (pupilMemberService.pupilIconUrl()) {
                <img [src]="pupilMemberService.pupilIconUrl()" class="pupil-logo-image dropdown-button" [alt]="this.pupilIconAltText(pupilMemberService.pupilIconUrl())" (click)="$event.stopPropagation(); accountHeader.toggleMenu()">
              }
            </div>
          }
          <!-- Right side: Burger Menu -->
          <div class="d-flex align-items-center">
            <app-account-header-component #accountHeader/>
          </div>
        </nav>
      </div>
    </div>
  </div>

</header>
